import Stack from '@carrier-io/air-react/Stack';
import AppTopBar from 'components/AppTopBar';
import SideBar from 'components/SideBar';
import { ReactNode } from 'react';

export const BaseLayout = ({ children }: { children: ReactNode }) => {
  document.body.style.backgroundColor = '#ffffff';

  return (
    <Stack direction="column">
      <AppTopBar />
      <Stack direction="row">
        <SideBar />
        {children}
      </Stack>
    </Stack>
  );
};
